import { render, staticRenderFns } from "./ShunyiPay.vue?vue&type=template&id=b5512c92&scoped=true"
import script from "./ShunyiPay.vue?vue&type=script&lang=js"
export * from "./ShunyiPay.vue?vue&type=script&lang=js"
import style0 from "./ShunyiPay.vue?vue&type=style&index=0&id=b5512c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5512c92",
  null
  
)

export default component.exports